import { useState, useRef } from 'react';
import { Link } from 'react-router-dom';
import classNames from 'classnames/bind';
import moment from 'moment';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronUp } from '@fortawesome/pro-regular-svg-icons/faChevronUp';
import { faChevronDown } from '@fortawesome/pro-regular-svg-icons/faChevronDown';

import capitalize from '../../../../../../helpers/capitalize';
import { checkAndRoun } from '../../../../../../helpers/topicsHelpers';

import ClassParticularsCell from '../../ClassParticularsCell';
import Tooltip from '../../../../../Tooltip';

import Styles from './styles.module.scss';

const cx = classNames.bind(Styles);

const TabTableSection = (props) => {
  const {
    currentPage, pageSize, currentData, hasInsightsAccess,
  } = props;
  const tableBodyRef = useRef();

  return (
    <div className={cx('capital-raise', { new_loading: currentData.newLoading, no_access: !hasInsightsAccess })}>
      <div className={Styles['capital-raise-header']}>
        <div className={Styles['capital-raise-row']}>
          <div className={cx('capital-raise-cell', 'rowNumber')}>#</div>
          <div className={cx('capital-raise-cell', 'classOfShare')}>Class of Shares</div>
          <div className={cx('capital-raise-cell', 'classParticulars')}>
            <span>
              Class Particulars
            </span>
            <Tooltip
              newIcon
              hasBigScreenDesign
              isCentered
              className={Styles.sharePrice_tooltip}
            >
              Descriptions and rights of share class.
            </Tooltip>
          </div>
          <div className={cx('capital-raise-cell', 'numberOfShares')}>
            <span>
              Number of Shares
            </span>
            <Tooltip
              newIcon
              hasBigScreenDesign
              isCentered
              className={Styles.sharePrice_tooltip}
            >
              Number of shares issued in the share class.
            </Tooltip>
          </div>
          <div className={cx('capital-raise-cell', 'valuation')}>Last Round Valuation</div>
          <div className={cx('capital-raise-cell', 'expandIcon')} />
        </div>
      </div>
      {!hasInsightsAccess && (
        <div className={Styles['capital-raise-access']}>
          <Link to="/pricing">Upgrade to UK Insights</Link>
          {' '}
          to use this feature.
        </div>
      )}
      <div className={Styles['capital-raise-body']} ref={tableBodyRef}>
        {currentData.data.map((obj, i) => (
          <TableRow
            // eslint-disable-next-line react/no-array-index-key
            key={i}
            currentData={obj}
            currentRow={((currentPage - 1) * pageSize) + (i + 1)}
          />
        ))}
      </div>
    </div>
  );
};

const TableRow = (props) => {
  const { currentData, currentRow } = props;
  const [isExpand, setIsExpand] = useState(false);

  return (
    <div className={cx('capital-raise-row-holder')}>
      <div className={Styles['capital-raise-row']}>
        <div className={cx('capital-raise-cell', 'rowNumber')}>
          {currentRow}
        </div>
        <div className={cx('capital-raise-cell', 'classOfShare')}>
          {capitalize(currentData.class)}
        </div>
        <div className={cx('capital-raise-cell', 'classParticulars')}>
          <ClassParticularsCell
            value={currentData.classParticulars}
          />
        </div>
        <div className={cx('capital-raise-cell', 'numberOfShares')}>
          {(currentData.numberOfShares || '').toLocaleString() || '-'}
        </div>
        <div className={cx('capital-raise-cell', 'valuation')}>
          {currentData.valuation ? checkAndRoun(currentData.valuation, 2, true, true, true) : '-'}
        </div>
        <div
          className={cx('capital-raise-cell', 'expandIcon')}
          onClick={() => setIsExpand(!isExpand)}
        >
          <FontAwesomeIcon icon={isExpand ? faChevronUp : faChevronDown} />
        </div>
      </div>
      {isExpand && (
      <div className={cx('capital-raise-extra')}>
        <div className={cx('capital-raise-extra-cell', 'currency')}>
          <div className={cx('capital-raise-extra-title')}>
            Currency
          </div>
          <div className={cx('capital-raise-extra-value')}>
            {currentData.currency}
          </div>
        </div>
        <div className={cx('capital-raise-extra-cell', 'date')}>
          <div className={cx('capital-raise-extra-title')}>
            Last Round Date
            <Tooltip
              newIcon
              hasBigScreenDesign
              isCentered
              className={Styles.sharePrice_tooltip}
            >
              The closing date of the last funding round that involved the share class.
            </Tooltip>
          </div>
          <div className={cx('capital-raise-extra-value')}>
            {currentData.date ? moment(currentData.date, 'YYYY-MM-DD').format('DD MMM YYYY') : ''}
          </div>
        </div>
        <div className={cx('capital-raise-extra-cell', 'sharePrice')}>
          <div className={cx('capital-raise-extra-title')}>
            Last Round Price Per Share
            <Tooltip
              newIcon
              hasBigScreenDesign
              isCentered
              className={Styles.sharePrice_tooltip}
            >
              This price is adjusted for any corporate actions such
              as splits and may not match with the original filing.
            </Tooltip>
          </div>
          <div className={cx('capital-raise-extra-value')}>
            {currentData.sharePrice ? checkAndRoun(currentData.sharePrice, 2, false, false, true) : '-'}
          </div>
        </div>
        <div className={cx('capital-raise-extra-cell', 'classParticulars')}>
          <div className={cx('capital-raise-extra-title')}>
            Class Particulars
            <Tooltip
              newIcon
              hasBigScreenDesign
              isCentered
              className={Styles.sharePrice_tooltip}
            >
              Descriptions and rights of share class.
            </Tooltip>
          </div>
          <div className={cx('capital-raise-extra-value')}>
            {currentData.classParticulars}
          </div>
        </div>
      </div>
      )}
    </div>
  );
};

export default TabTableSection;
